module.exports = __webpack_public_path__ + "img/no_notification.53ad8649.png";